import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

const Material = [
  MatIconModule,
];
@Component({
  selector: 'eq-alert-error',
  standalone: true,
  imports: [
    CommonModule,
    ...Material
  ],
  templateUrl: './alert-error.component.html',
  styleUrl: './alert-error.component.scss',
})
export class AlertErrorComponent{
  @Input('initLabel') initLabel: string = '';
  @Input('label') label: string = '';
}
